import type { NotificationDTO } from "@shared/types/notifications";
import { NotificationItem } from "./NotificationItem";

interface NotificationListProps {
  notifications: NotificationDTO[];
  onMarkRead: (id: string) => void;
}

export function NotificationList({ notifications, onMarkRead }: NotificationListProps) {
  return (
    <ul className="space-y-2">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onMarkRead={onMarkRead}
        />
      ))}
    </ul>
  );
}
